import React from "react";
import {
  FiHelpCircle,
  FiInfo,
  FiPhoneCall,
  FiMail,
  FiUserCheck,
  FiLock,
  FiShield,
  FiCheckCircle,
  FiMessageCircle,
  FiUsers,
  FiSearch,
} from "react-icons/fi";

import heroImg from "../../assets/img/couple3.jpg"; // Use any support-style image
import PageCount from "../../component/utils/PageCount";

function Help() {
  return (
    <div className="help-page">

<PageCount pageName = {"Help"}/>
      {/* ⭐ HERO SECTION */}
      <section className="help-hero mb-3">
        <div className="hero-left">
          <h1>
            Need <span>Help?</span>
          </h1>
          <p className="subtitle">
            We’re here to guide you at every step of your Soulsathi journey.
          </p>
          <p>
            Whether you're facing issues with your profile, searching for a match, 
            chatting, privacy settings, or payments — this Help Center covers everything 
            you need to use Soulsathi.com smoothly and safely.
          </p>
        </div>

        <div className="hero-right">
          <img src={heroImg} alt="Help and Support Soulsathi" />
        </div>
      </section>

      {/* ⭐ HOW PLATFORM WORKS */}
      <section className="how-it-works-section container  mb-3">
        <h2>
          How <span>Soulsathi Works?</span>
        </h2>

        <div className="how-grid">
          <div className="how-item">
            <FiUserCheck className="icon" />
            <h3>Create Your Profile</h3>
            <p>
              Add your basic details, preferences, lifestyle & background information to help 
              us find the most compatible matches for you.
            </p>
          </div>

          <div className="how-item">
            <FiSearch className="icon" />
            <h3>Search & Discover Matches</h3>
            <p>
              Browse profiles using filters like community, religion, occupation, education, 
              location & compatibility.
            </p>
          </div>

          <div className="how-item">
            <FiMessageCircle className="icon" />
            <h3>Connect & Communicate</h3>
            <p>
              Send interests, start chats, and communicate safely using our secure messaging system.
            </p>
          </div>

          <div className="how-item">
            <FiCheckCircle className="icon" />
            <h3>Finalize Genuine Connections</h3>
            <p>
              Once you find a match, take your conversation forward confidently while keeping privacy intact.
            </p>
          </div>
        </div>
      </section>

      {/* ⭐ HELP TOPICS */}
      <section className="help-topics-section container mb-3">
        <h2>
          Popular <span>Help Topics</span>
        </h2>

        <div className="topics-grid">
          <div className="topic-card">
            <FiUserCheck className="icon" />
            <h3>Account & Profile Issues</h3>
            <p>Update profile, photo upload issues, login OTP problems & more.</p>
          </div>

          <div className="topic-card">
            <FiSearch className="icon" />
            <h3>Match Search Issues</h3>
            <p>Fix match visibility, filters, and recommendation problems.</p>
          </div>

          <div className="topic-card">
            <FiMessageCircle className="icon" />
            <h3>Chat & Communication</h3>
            <p>Learn how to send interests, respond, and chat safely.</p>
          </div>

          <div className="topic-card">
            <FiLock className="icon" />
            <h3>Privacy & Safety</h3>
            <p>Control who sees your profile and stay protected.</p>
          </div>

          <div className="topic-card">
            <FiShield className="icon" />
            <h3>Verification Help</h3>
            <p>ID verification steps & how verification improves match quality.</p>
          </div>

          <div className="topic-card">
            <FiInfo className="icon" />
            <h3>Other General Queries</h3>
            <p>General help related to membership, guidelines & rules.</p>
          </div>
        </div>
      </section>

      {/* ⭐ FAQ SECTION */}
       
      {/* ⭐ CONTACT SUPPORT */}
      <section className="contact-section container mb-3">
        <h2>
          Contact <span>Support</span>
        </h2>

        <p className="contact-text">
          Our support team is available to help you with any issue related to 
          registration, matchmaking, payments, reporting, or safety concerns.
        </p>

        <div className="contact-grid">
          {/* <div className="contact-item">
            <FiPhoneCall className="icon" />
            <h3>Phone Support</h3>
            <p>+91 98765 43210</p>
          </div>

          <div className="contact-item">
            <FiMail className="icon" />
            <h3>Email Support</h3>
            <p>support@soulsathi.com</p>
          </div> */}

          <div className="contact-item">
            <FiHelpCircle className="icon" />
            <h3>Help Request</h3>
            <p>Use the in-app “Help & Support” form anytime.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Help;
